// @owners { team: patients-team }
import { type FertilityCycleMedicationType } from '@alto/scriptdash/alto/fertility_cycles/types/v1/fertility_cycle_medication_type';
import { isNil, omitBy } from 'lodash';
import { createSelector } from 'reselect';
import { getEligiblePrescriptionMedTypes } from './getEligiblePrescriptionMedTypes';
import { getProgynyWizardUpdateAttributes } from '~shared/selectors/checkout/progyny';
import { type ReduxStateShared } from '~shared/types';

export type DaysSupplyOnHandByMedType = Record<FertilityCycleMedicationType, number>;

export const getDaysSupplyOnHandByMedType: (state: ReduxStateShared) => Partial<DaysSupplyOnHandByMedType> =
  createSelector(
    [getEligiblePrescriptionMedTypes, getProgynyWizardUpdateAttributes],
    (medTypes: FertilityCycleMedicationType[], updateAttributes: Record<string, any>) => {
      const supplyOnHandByMedType: Record<FertilityCycleMedicationType, number | null> = {
        gonal_f: null,
        menopur: null,
        cetrotide: null,
        any: null,
      };
      medTypes.forEach((medType) => {
        const updateAttrMed = updateAttributes?.medications?.find(
          (med: { medication_type: FertilityCycleMedicationType }) => med.medication_type === medType,
        );
        supplyOnHandByMedType[medType] = Number(updateAttrMed?.supply_on_hand?.days_supply);
      });

      return omitBy(supplyOnHandByMedType, isNil);
    },
  );
